import { render, staticRenderFns } from "./IolResultToricTable.vue?vue&type=template&id=6f048028"
import script from "./IolResultToricTable.vue?vue&type=script&lang=js"
export * from "./IolResultToricTable.vue?vue&type=script&lang=js"
import style0 from "./IolResultToricTable.vue?vue&type=style&index=0&id=6f048028&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports